module.exports = "/assets/b09c669d7b99d42661090161c1f57396.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3G.png
// module id = 2138
// module chunks = 0